import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CrmSegment } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { ApiCollectionResponse, GetCollectionQueryParams } from '../../types';

export type GetCrmSegmentsParams = GetCollectionQueryParams<CrmSegment> & {
  integrationId: string;
  forceSync?: boolean;
};

export const getCrmSegments = async (
  params: GetCrmSegmentsParams
): Promise<ApiCollectionResponse<CrmSegment>> => {
  return await tinctApi.crmIntegrations.getCrmSegments(params);
};

export const useGetCrmSegments = (
  params: GetCrmSegmentsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<CrmSegment>, ApiError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery({
    queryKey: ['crm-segments', params],
    queryFn: () => getCrmSegments(params),
    ...options,
  });
